<template>
  <v-app>
    <div v-if="showLoading">
      <loading-animation :message="loadingMsg" />
    </div>
    <div v-if="!showLoading">
      <navigation-drawer v-if="showAppShell" />
      <app-bar v-if="showAppShell" />
      <cart-drawer v-if="showAppShell" />
      <default-view />
    </div>
  </v-app>
  <snack-bar mode="default" />
  <notification-snack-bar />
</template>

<script lang="ts" setup>
import NavigationDrawer from "@/shared/components/NavigationDrawer.vue";
import AppBar from "@/shared/components/AppBar.vue";
import DefaultView from "@/app/layouts/default/View.vue";
import SnackBar from "@/shared/components/SnackBar.vue";
import { useAuthStore } from "@/auth/stores/auth";
import { computed, ref } from "vue";
import LoadingAnimation from "@/shared/components/Common/LoadingAnimation.vue";
import NotificationSnackBar from "@/shared/components/NotificationSnackBar.vue";
import CartDrawer from "@/cart/components/cart/CartDrawer.vue";
import i18n from "@/app/plugins/i18n";
import { useRoute } from "vue-router";

// Select a random loading message once on component mount
const MAX_DEFINED_LANGUAGE_STRINGS = 15;
const randomNum = Math.floor(Math.random() * MAX_DEFINED_LANGUAGE_STRINGS) + 1;
const selectedLoadingMessage = ref(i18n.global.t(`platform.loginLoading${randomNum}`));

const loadingMsg = computed(() => {
  if (useAuthStore().changeSessionLoading) {
    return i18n.global.t("platform.changeSessionLoading");
  }
  if (useAuthStore().logoutLoading) {
    return i18n.global.t("platform.logoutLoading");
  }
  // Use the pre-selected random message
  return selectedLoadingMessage.value;
});

const route = useRoute();
const showAppShell = computed(() => {
  const isLoggedIn = useAuthStore().isLoggedIn;
  const hideAppShell = Boolean(route.meta?.hideAppShell);
  return isLoggedIn && !hideAppShell;
});

const showLoading = computed(() => {
  return (
    useAuthStore().loading || useAuthStore().changeSessionLoading || useAuthStore().logoutLoading
  );
});
</script>
